import { FC } from 'react'
import { StyleSheet } from 'react-native'
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated'

const Backdrop: FC = () => {
    return <Animated.View entering={FadeIn} exiting={FadeOut} style={styles.container} />
}

const styles = StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: 1,
    },
})

export default Backdrop
